import React from "react";
import { useNavigate } from "react-router-dom";

const TutorPayrollErrorState = ({ error, onRetry }) => {
  const navigate = useNavigate();

  // Check if error is due to token expiration
  const isTokenExpiredError =
    error?.message?.includes("expired") ||
    error?.message?.includes("session") ||
    error?.message?.includes("401") ||
    error?.message?.includes("Unauthorized");
  const styles = {
    errorContainer: {
      backgroundColor: "#fee2e2",
      border: "1px solid #fecaca",
      borderRadius: "0.5rem",
      padding: "2rem",
      textAlign: "center",
      maxWidth: "600px",
      margin: "2rem auto",
    },
    errorIcon: {
      fontSize: "3rem",
      marginBottom: "1rem",
    },
    errorTitle: {
      fontSize: "1.25rem",
      fontWeight: "600",
      color: "#991b1b",
      margin: "0 0 0.5rem 0",
    },
    errorMessage: {
      color: "#991b1b",
      opacity: "0.8",
      margin: "0 0 1.5rem 0",
      lineHeight: "1.5",
    },
    retryButton: {
      backgroundColor: "#001272",
      color: "white",
      border: "none",
      borderRadius: "0.375rem",
      padding: "0.75rem 1.5rem",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background-color 0.2s",
    },
    retryButtonHover: {
      backgroundColor: "#b91c1c",
    },
  };

  return (
    <div style={styles.errorContainer}>
      <div style={styles.errorIcon}>{isTokenExpiredError ? "🔒" : "⚠️"}</div>
      <h3 style={styles.errorTitle}>
        {isTokenExpiredError
          ? "Session Expired"
          : "Failed to Load Payroll Details"}
      </h3>
      <p style={styles.errorMessage}>
        {isTokenExpiredError
          ? "Your session has expired. Please log in again to continue."
          : error?.message || "Unable to load payroll details for this tutor"}
      </p>

      {isTokenExpiredError ? (
        <div style={{ marginTop: "1rem" }}>
          <button
            style={styles.retryButton}
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/login");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.retryButtonHover.backgroundColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.retryButton.backgroundColor;
            }}
          >
            Go to Login
          </button>
        </div>
      ) : (
        onRetry && (
          <div style={{ marginTop: "1rem" }}>
            <button
              style={styles.retryButton}
              onClick={onRetry}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  styles.retryButtonHover.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  styles.retryButton.backgroundColor;
              }}
            >
              Retry
            </button>
          </div>
        )
      )}
    </div>
  );
};

export default TutorPayrollErrorState;
